import { PageHeader } from 'ui/pageHeader';
import { PrimaryButton } from 'ui/button';
import { Add16 } from 'ui/icons';
import { StyledButtonLabel, StyledLink } from './WorkflowWebhookIndexPage.styles';

export const WorkflowWebhookIndexHeader = () => (
  <PageHeader
    data-test="workflow-webhook-index-page-header"
    pageActions={
      <StyledLink to="/workflows/webhooks/create">
        <PrimaryButton data-test="create-workflow-webhook-button">
          <Add16 />
          <StyledButtonLabel>New webhook</StyledButtonLabel>
        </PrimaryButton>
      </StyledLink>
    }
  >
    Journey Webhooks
  </PageHeader>
);
